<template>
  <Modal v-model="moveGroupingModal" :title="$t('key1003203')" width="500" :transfer="false"
    :mask-closable="false" @on-visible-change="moveGroupingModalChange">
    <Form ref="moveGroupingForm" :model="moveGroupingForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row style="width: 80%;">
        <h2 class="font-weight-bold mb8 font-size-13 flex align-items-center pl29">
          <span>{{ $t('key1000365') }}</span>
          <span class="mr5 ml5 themeColor">{{ moveGroupingData.length }}</span>
          <span>{{ $t('key1001120') }}</span>
        </h2>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003212')" prop="ymsMerchantGroupId">
            <Select v-model="moveGroupingForm.ymsMerchantGroupId" filterable transfer :placeholder="$t('key1003211')">
              <Option v-for="item in moveGroupingList" :value="item.ymsMerchantGroupId">{{ item.groupName }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="moveGroupingModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="moveGroupingBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "moveGroupingModal",
  mixins: [Mixin],
  props: {
    moveGroupingList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      moveGroupingModal: false,
      moveGroupingForm: {
        ymsMerchantGroupId: null
      },
      ruleValidate: {
        ymsMerchantGroupId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003211'), trigger: 'change'}
        ]
      },
      moveGroupingData: []
    };
  },
  created() {

  },
  methods: {
    // 初始化数据
    initMoveGroupingData(data) {
      this.$refs['moveGroupingForm'].resetFields();
      this.moveGroupingData = data;
      this.moveGroupingModal = true;
    },
    // 保存按钮
    moveGroupingBtn() {
      let v = this;
      let query = {
        ids: v.moveGroupingData.map((item) => {
          return item.ymsMerchantId;
        }),
        ymsMerchantGroupId: v.moveGroupingForm.ymsMerchantGroupId
      };
      v.$refs['moveGroupingForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_ymsDistributorMerchant_mobileGrouping, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.moveGroupingModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    moveGroupingModalChange(value) {
      let v = this;
      if (!value) {
        v.moveGroupingData = [];
        v.$refs['moveGroupingForm'].resetFields();
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>